// extracted by mini-css-extract-plugin
module.exports = {"actionButton":"Suggestion_actionButton__247Vy","imageWrapper":"Suggestion_imageWrapper__2S7Pj","votesWrapper":"Suggestion_votesWrapper__3Rgai"};